
import { useParams } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";

import {
  CategoriesData,
  pistolsData,
  riflesData,
  midTierData,
  knivesData,
  glovesData,
  casesData,
  collectionsData,
  stickersData,
  agentsData
} from "./allItems"; // You create this file to export all arrays

import Header from "../../component/Header.jsx";
import PaymentModal from "../../component/PaymentModal.jsx";

import AlsoNeed from "../../pages/CategoriesPageSection/alsoneed.jsx";
import ProductDetail from "../../pages/CategoriesPageSection/productdetail.jsx";
import RelatedProduct from "../../pages/CategoriesPageSection/relatedproduct.jsx";

import cardbg from "../../media3/items/cardbg.svg";
import damage from "../../media3/items/damage.svg";
import accuracy from "../../media3/items/accuracy.svg";
import rate from "../../media3/items/rate.svg";
import control from "../../media3/items/control.svg";
import range from "../../media3/items/range.svg";
import capacity from "../../media3/items/capacity.svg";

import "../../style/pages/categoriespage/items.css";
import "../../style/pages/categoriespage/alsoneed.css";
import "../../style/pages/categoriespage/productdetail.css";
import "../../style/pages/categoriespage/relatedproduct.css";

const DEFAULT_STATS = {
  damage: 30,
  accuracy: 60,
  rateOfFire: 70,
  control: 50,
  range: 50,
  magazineCapacity: 15
};

// stat row component
const StatRow = ({ icon, label, value }) => {
  const blocks = Math.round(value / 20);
  return (
    <div className="stat-item6">
      <img src={icon} alt={label} className="stat-icon" />
      <div className="stat-info">
        <span className="stat-label">{label}</span>
        <div className="stat-blocks">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className={`block ${i < blocks ? "filled" : ""}`}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

function Items({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const { name } = useParams();
  const decodedName = decodeURIComponent(name);

  // memoized all items list
  const allItems = useMemo(
    () => [
      ...CategoriesData,
      ...pistolsData,
      ...riflesData,
      ...midTierData,
      ...knivesData,
      ...glovesData,
      ...casesData,
      ...collectionsData,
      ...stickersData,
      ...agentsData
    ],
    []
  );

  const item = allItems.find((x) => x.name === decodedName);
  const initialSuggested = allItems
    .filter((i) => i.category === item?.category && i.name !== item?.name)
    .slice(0, 3);

  const [mainItem, setMainItem] = useState(item);
  const [suggested, setSuggested] = useState(initialSuggested);
  const [isRotating, setIsRotating] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  // const stats = item?.stats || DEFAULT_STATS;
  const stats = mainItem?.stats || DEFAULT_STATS;

  // update when URL changes
  useEffect(() => {
    setMainItem(item);
    setSuggested(initialSuggested);
  }, [decodedName]);

  if (!item) return <div className="items-page">Item not found.</div>;

  const handleSuggestedClick = (idx) => {
    const clicked = suggested[idx];
    const updated = [...suggested];
    updated[idx] = mainItem;
    setMainItem(clicked);
    setSuggested(updated);
  };

  const handleBuyClick = () => {
    if (!isLoggedIn) return setLoginModalOpen(true);
    setSelectedItem(mainItem);
    setIsPaymentModalOpen(true);
  };

  const handleClosePaymentModal = () => {
    setIsPaymentModalOpen(false);
    setSelectedItem(null);
  };

  return (
    <div className="items-page">
      <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />

      <div className="items-content">
        <div className="item-left">
          {/* <h1 className="item-title">{item.name.toUpperCase()}</h1>
          <div className="item-rarity">[ RARITY {item.rarity.toUpperCase()} ]</div> */}
          <h1 className="item-title">{mainItem.name.toUpperCase()}</h1>
          <div className="item-rarity">[ RARITY {mainItem.rarity.toUpperCase()} ]</div>

          {/* <p
            className="item-desc"
            dangerouslySetInnerHTML={{
              __html: (item.description || "").replace(/\n/g, "<br />")
            }}
          /> */}
          <p
          className="item-desc"
          dangerouslySetInnerHTML={{
            __html: (mainItem.description || "").replace(/\n/g, "<br />")
          }}
        />
       <p className="item-desc">
        A detailed cosmetic finish crafted to enhance your loadout with bold patterns and defined texture work.
        Designed to stand out without affecting gameplay. Exclusive to The SkinForge.
        Each design undergoes a precision crafting process that ensures visual depth, vibrant color blending, 
        and in-game clarity. Built for collectors who value both performance and aesthetics, 
        this finish redefines customization at every level.
      </p>
          <div className="item-stats-grid">
            <StatRow icon={damage} label="Damage" value={stats.damage} />
            <StatRow icon={accuracy} label="Accuracy" value={stats.accuracy} />
            <StatRow icon={rate} label="Rate Of Fire" value={stats.rateOfFire} />
            <StatRow icon={control} label="Control" value={stats.control} />
            <StatRow icon={range} label="Range" value={stats.range} />
            <StatRow icon={capacity} label="Mag Capacity" value={stats.magazineCapacity} />
          </div>
        </div>

        <div className="item-right">
          <div
            className="weapon-container"
            onMouseEnter={() => setIsRotating(true)}
            onMouseLeave={() => setIsRotating(false)}
          >
            <div className="weapon-bg">
              <img
                src={mainItem.img}
                alt={mainItem.name}
                className="weapon-image"
              />
            </div>
            <div className="action-buttons">
              <button className="btn-buy" onClick={handleBuyClick}>
                BUY
              </button>
            </div>
          </div>

          <div className="suggested-items">
            {suggested.map((s, idx) => (
              <div
                className="suggested-item"
                key={idx}
                onClick={() => handleSuggestedClick(idx)}
              >
                <img src={s.img} alt={s.name} />
                <div className="suggested-level">LVL {80 + idx * 15}</div>
                <div className="suggested-name">{s.name}</div>
              </div>
            ))}
          </div>

          {selectedItem && (
            <PaymentModal
              isOpen={isPaymentModalOpen}
              onClose={handleClosePaymentModal}
              itemName={selectedItem.name}
              itemPrice={selectedItem.price}
              isLoggedIn={isLoggedIn}
            />
          )}
        </div>
      </div>

      <AlsoNeed />
      <ProductDetail />
      <RelatedProduct />
    </div>
  );
}

export default Items;
